var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M4.08989 9.82031C4.08989 10.0277 4.2563 10.1953 4.46255 10.1953H7.53755C7.7438 10.1953 7.9102 10.0277 7.9102 9.82031V7.52344H4.08989V9.82031ZM10.3137 1.80469H1.68637C1.39927 1.80469 1.21997 2.11758 1.36411 2.36719L3.95747 6.77344H8.04497L10.6383 2.36719C10.7801 2.11758 10.6008 1.80469 10.3137 1.80469Z",
          fill: "black",
          "fill-opacity": "0.25",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }